import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import geografiaFunciones from "../function/geografia.Funciones";
import {
  generarEdades,
  generarGruposSanguineos,
  generarSexos,
} from "../function/listascomunes.Funciones";
import { normalizeImage } from "../utils/image";

const MODULO = "MiPerfil";

const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const getHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";

  return {
    Authorization: `Bearer ${token}`,
  };
};

const Mi_Perfil_Editar = () => {
  const navigate = useNavigate();

  const [documentoInstructor, setDocumentoInstructor] = useState("");
  const [tipodocumentoInstructor, setTipodocumentoInstructor] = useState("");
  const [nombre1Instructor, setNombre1Instructor] = useState("");
  const [nombre2Instructor, setNombre2Instructor] = useState("");
  const [apellido1Instructor, setApellido1Instructor] = useState("");
  const [apellido2Instructor, setApellido2Instructor] = useState("");
  const [fechanacimientoInstructor, setFechanacimientoInstructor] = useState("");
  const [edadInstructor, setEdadInstructor] = useState("");
  const [sexoInstructor, setSexoInstructor] = useState("");
  const [rhInstructor, setRhInstructor] = useState("");
  const [emailInstructor, setEmailInstructor] = useState("");

  const [telefono1Instructor, setTelefono1Instructor] = useState("");
  const [telefono2Instructor, setTelefono2Instructor] = useState("");
  const [direccionInstructor, setDireccionInstructor] = useState("");

  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [paisInstructor, setPaisInstructor] = useState("");
  const [estadoInstructor, setEstadoInstructor] = useState("");
  const [ciudadInstructor, setCiudadInstructor] = useState("");

  const [paisSeleccionado, setPaisSeleccionado] = useState("");
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState("");

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const previewRef = useRef("");

  const [uploadState, setUploadState] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cargandoPerfil, setCargandoPerfil] = useState(true);

  const edades = generarEdades();
  const sexos = generarSexos();
  const gruposSanguineos = generarGruposSanguineos();

  const getModuloMiPerfil = () => {
    try {
      const permisosStorage = localStorage.getItem("permisos");
      const usuarioStorage = localStorage.getItem("usuario");
      const userStorage = localStorage.getItem("user");
      const usuariosStorage = localStorage.getItem("usuarios");

      const permisosData = permisosStorage
        ? JSON.parse(permisosStorage)
        : usuarioStorage
        ? JSON.parse(usuarioStorage)
        : userStorage
        ? JSON.parse(userStorage)
        : usuariosStorage
        ? JSON.parse(usuariosStorage)
        : {};

      const modulos = Array.isArray(permisosData)
        ? permisosData
        : permisosData?.modulos ||
          permisosData?.permisos ||
          permisosData?.usuario?.modulos ||
          permisosData?.usuario?.permisos ||
          permisosData?.user?.modulos ||
          permisosData?.user?.permisos ||
          [];

      const moduloBuscado = normalizarTexto(MODULO);

      return (
        modulos.find((modulo) => {
          const nombre =
            modulo?.nombreModulo || modulo?.modulo || modulo?.nombre || "";

          return normalizarTexto(nombre) === moduloBuscado;
        }) || {}
      );
    } catch (error) {
      console.error("Error leyendo permisos MiPerfil:", error);
      return {};
    }
  };

  const moduloMiPerfil = useMemo(() => getModuloMiPerfil(), []);

  const puedeActualizar =
    moduloMiPerfil?.puedeActualizar === true ||
    moduloMiPerfil?.actualizar === true ||
    moduloMiPerfil?.editar === true ||
    moduloMiPerfil?.update === true;

  const cargarDatosPerfil = async (perfilData, isMounted = true) => {
    const fechaNacimiento = perfilData.fechanacimientoInstructor
      ? new Date(perfilData.fechanacimientoInstructor)
          .toISOString()
          .split("T")[0]
      : "";

    setDocumentoInstructor(perfilData.documentoInstructor || "");
    setTipodocumentoInstructor(perfilData.tipodocumentoInstructor || "");
    setNombre1Instructor(perfilData.nombre1Instructor || "");
    setNombre2Instructor(perfilData.nombre2Instructor || "");
    setApellido1Instructor(perfilData.apellido1Instructor || "");
    setApellido2Instructor(perfilData.apellido2Instructor || "");
    setFechanacimientoInstructor(fechaNacimiento);
    setEdadInstructor(perfilData.edadInstructor || "");
    setSexoInstructor(perfilData.sexoInstructor || "");
    setRhInstructor(perfilData.rhInstructor || "");
    setEmailInstructor(perfilData.emailInstructor || "");
    setTelefono1Instructor(perfilData.telefono1Instructor || "");
    setTelefono2Instructor(perfilData.telefono2Instructor || "");
    setDireccionInstructor(perfilData.direccionInstructor || "");
    setPaisInstructor(perfilData.paisInstructor || "");
    setEstadoInstructor(perfilData.estadoInstructor || "");
    setCiudadInstructor(perfilData.ciudadInstructor || "");

    if (perfilData.imgInstructor) {
      setPreview(perfilData.imgInstructor);
      previewRef.current = perfilData.imgInstructor;
    }

    const paisesData = await geografiaFunciones.obtenerPaises();

    if (!isMounted) return;

    const paisesUnicos = paisesData.filter(
      (pais, index, self) =>
        index === self.findIndex((p) => p.idPais === pais.idPais)
    );

    setPaises(paisesUnicos);

    if (perfilData.paisInstructor) {
      const estadosData = await geografiaFunciones.obtenerEstadosPorPais(
        perfilData.paisInstructor
      );

      if (!isMounted) return;

      const estadosUnicos = estadosData.filter(
        (estado, index, self) =>
          index === self.findIndex((e) => e.idEstado === estado.idEstado)
      );

      setEstados(estadosUnicos);
      setPaisSeleccionado(String(perfilData.paisInstructor));
    }

    if (perfilData.estadoInstructor) {
      const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(
        perfilData.estadoInstructor
      );

      if (!isMounted) return;

      const ciudadesUnicas = ciudadesData.filter(
        (ciudad, index, self) =>
          index === self.findIndex((c) => c.idCiudad === ciudad.idCiudad)
      );

      setCiudades(ciudadesUnicas);
      setEstadoSeleccionado(String(perfilData.estadoInstructor));
    }

    if (perfilData.ciudadInstructor) {
      setCiudadSeleccionada(String(perfilData.ciudadInstructor));
    }
  };

  useEffect(() => {
    let isMounted = true;

    const cargarPerfil = async () => {
      try {
        setCargandoPerfil(true);

        const { data } = await axios.get("/api/perfil", {
          headers: getHeaders(),
        });

        if (!data?.ok) {
          Swal.fire(
            "Perfil no encontrado",
            data?.message || "No se encontró información del perfil.",
            "warning"
          );
          return;
        }

        if (!isMounted) return;

        await cargarDatosPerfil(data.message || {}, isMounted);
      } catch (error) {
        if (!isMounted) return;

        console.error(
          "Error al cargar perfil:",
          error.response?.data || error.message
        );

        if (error.response?.status === 401) {
          Swal.fire("Sesión expirada", "Ingrese nuevamente.", "warning");
          localStorage.clear();
          sessionStorage.clear();
          navigate("/");
          return;
        }

        Swal.fire(
          "Error",
          error.response?.data?.message || "No se pudo cargar el perfil.",
          "error"
        );
      } finally {
        if (isMounted) setCargandoPerfil(false);
      }
    };

    cargarPerfil();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  const actualizarPerfil = async (formData) => {
    try {
      setLoading(true);

      const { data } = await axios.put("/api/perfil", formData, {
        headers: {
          ...getHeaders(),
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: ({ loaded, total }) => {
          const percent = total ? parseInt((loaded * 100) / total) : 0;
          setUploadState(percent);
        },
      });

      Swal.fire({
        icon: "success",
        title: data.message || "Perfil actualizado correctamente",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate("/perfil"));
    } catch (error) {
      console.error(
        "Error al actualizar perfil:",
        error.response?.data || error.message
      );

      Swal.fire({
        icon: "error",
        title: "Error en la actualización",
        text: error.response?.data?.message || "Intenta de nuevo",
      });
    } finally {
      setLoading(false);
    }
  };

  const actions = async (e) => {
    e.preventDefault();

    if (!puedeActualizar) {
      Swal.fire(
        "Sin permisos",
        "No tiene permisos para actualizar Mi Perfil.",
        "warning"
      );
      return;
    }

    const formData = new FormData();

    if (image) {
      formData.append("imgInstructor", image);
    }

    const perfilData = {
      emailInstructor,
      telefono1Instructor,
      telefono2Instructor: telefono2Instructor ?? "",
      direccionInstructor,
      paisInstructor: paisInstructor || paisSeleccionado || 0,
      estadoInstructor: estadoInstructor || estadoSeleccionado || 0,
      ciudadInstructor: ciudadInstructor || ciudadSeleccionada || 0,
    };

    Object.entries(perfilData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    actualizarPerfil(formData);
  };

  const handlePaisChange = async (paisId) => {
    try {
      setPaisSeleccionado(paisId);
      setPaisInstructor(paisId);
      setEstados([]);
      setCiudades([]);
      setEstadoSeleccionado("");
      setCiudadSeleccionada("");
      setEstadoInstructor("");
      setCiudadInstructor("");

      if (paisId) {
        const estadosData =
          await geografiaFunciones.obtenerEstadosPorPais(paisId);

        const estadosUnicos = estadosData.filter(
          (estado, index, self) =>
            index === self.findIndex((e) => e.idEstado === estado.idEstado)
        );

        setEstados(estadosUnicos);
      }
    } catch (error) {
      console.error("Error al cambiar el país:", error);
    }
  };

  const handleEstadoChange = async (estadoId) => {
    try {
      setEstadoSeleccionado(estadoId);
      setEstadoInstructor(estadoId);
      setCiudades([]);
      setCiudadSeleccionada("");
      setCiudadInstructor("");

      if (estadoId) {
        const ciudadesData =
          await geografiaFunciones.obtenerCiudadesPorEstado(estadoId);

        const ciudadesUnicas = ciudadesData.filter(
          (ciudad, index, self) =>
            index === self.findIndex((c) => c.idCiudad === ciudad.idCiudad)
        );

        setCiudades(ciudadesUnicas);
      }
    } catch (error) {
      console.error("Error al cambiar el estado:", error);
    }
  };

  const handleCiudadChange = (ciudadId) => {
    setCiudadSeleccionada(ciudadId);
    setCiudadInstructor(ciudadId);
  };

  const handleFileChange = async (e) => {
    try {
      if (!e.target.files || !e.target.files[0]) return;

      const file = e.target.files[0];
      const processed = await normalizeImage(file);

      if (preview && preview.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(preview);
        } catch (err) {}
      }

      setImage(processed);

      const blobUrl = URL.createObjectURL(processed);
      setPreview(blobUrl);
      previewRef.current = blobUrl;

      const label = document.getElementById("fileLabel");
      const fileNameInput = document.getElementById("fileName");

      if (fileNameInput) fileNameInput.value = processed.name || "imagen.jpg";
      if (label) label.textContent = "Seleccionar / Cambiar";
    } catch (err) {
      console.error("Error procesando imagen:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo procesar la imagen.",
      });
    }
  };

  if (cargandoPerfil) {
    return (
      <div className="container py-5">
        <div className="text-center">
          <div className="spinner-border text-dark" />
          <p className="mt-3 text-secondary">Cargando Mi Perfil...</p>
        </div>
      </div>
    );
  }

  if (!puedeActualizar) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning text-center rounded-4">
          No tiene permisos para actualizar Mi Perfil.
        </div>

        <div className="text-center">
          <button
            className="btn btn-dark mt-3"
            onClick={() => navigate("/perfil")}
          >
            Volver a Mi Perfil
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-body-tertiary py-4">
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <h4 className="mb-1 fw-semibold">Editar Mi Perfil</h4>

              <p className="mb-0 text-secondary small">
                Actualiza únicamente tu información de contacto, ubicación y
                fotografía.
              </p>
            </div>

            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={() => navigate("/perfil")}
              disabled={loading}
            >
              <i className="fa-solid fa-arrow-left me-2"></i>
              Volver
            </button>
          </div>
        </div>

        <form onSubmit={actions}>
          <div className="row g-4">
            <div className="col-12 col-lg-9">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
                <h6 className="mb-0 fw-semibold">Datos personales</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <InputTexto label="Nombre 1" value={nombre1Instructor} setValue={setNombre1Instructor} disabled />
                  <InputTexto label="Nombre 2" value={nombre2Instructor} setValue={setNombre2Instructor} disabled />
                  <InputTexto label="Apellido 1" value={apellido1Instructor} setValue={setApellido1Instructor} disabled />
                  <InputTexto label="Apellido 2" value={apellido2Instructor} setValue={setApellido2Instructor} disabled />

                  <InputTexto
                    label="Tipo de documento"
                    value={tipodocumentoInstructor}
                    setValue={setTipodocumentoInstructor}
                    disabled
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Número de documento"
                    value={documentoInstructor}
                    setValue={setDocumentoInstructor}
                    disabled
                    col="col-12 col-md-6"
                  />

                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary text-uppercase">
                      Fecha de nacimiento
                    </label>

                    <input
                      type="date"
                      className="form-control"
                      value={fechanacimientoInstructor}
                      disabled
                      readOnly
                    />
                  </div>

                  <SelectSimple label="Edad" value={edadInstructor} setValue={setEdadInstructor} opciones={edades} disabled />
                  <SelectSimple label="Sexo" value={sexoInstructor} setValue={setSexoInstructor} opciones={sexos.map((s) => s.valor)} disabled />
                  <SelectSimple label="RH" value={rhInstructor} setValue={setRhInstructor} opciones={gruposSanguineos} disabled />
                </div>
              </div>

              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
                <h6 className="mb-0 fw-semibold">Contacto</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <InputTexto
                    label="Correo electrónico / Usuario"
                    value={emailInstructor}
                    setValue={setEmailInstructor}
                    type="email"
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Teléfono 1 *"
                    value={telefono1Instructor}
                    setValue={setTelefono1Instructor}
                    required
                    type="tel"
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Teléfono 2"
                    value={telefono2Instructor}
                    setValue={setTelefono2Instructor}
                    type="tel"
                    col="col-12 col-md-6"
                  />

                  <InputTexto
                    label="Dirección *"
                    value={direccionInstructor}
                    setValue={setDireccionInstructor}
                    required
                    col="col-12 col-md-6"
                  />
                </div>
              </div>

              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <h6 className="mb-0 fw-semibold">Lugar de Nacimiento</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      País
                    </label>

                    <select
                      className="form-select"
                      onChange={(e) => handlePaisChange(e.target.value)}
                      value={paisSeleccionado || paisInstructor || ""}
                    >
                      <option value="">Seleccione un país</option>

                      {paises.map((pais) => (
                        <option key={pais.idPais} value={pais.idPais}>
                          {pais.nombrePais}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      Estado
                    </label>

                    <select
                      className="form-select"
                      onChange={(e) => handleEstadoChange(e.target.value)}
                      value={estadoSeleccionado || estadoInstructor || ""}
                      disabled={!paisSeleccionado && !paisInstructor}
                    >
                      <option value="">Seleccione un estado</option>

                      {estados.map((estado) => (
                        <option key={estado.idEstado} value={estado.idEstado}>
                          {estado.nombreEstado}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      Ciudad
                    </label>

                    <select
                      className="form-select"
                      onChange={(e) => handleCiudadChange(e.target.value)}
                      value={ciudadSeleccionada || ciudadInstructor || ""}
                      disabled={!estadoSeleccionado && !estadoInstructor}
                    >
                      <option value="">Seleccione una ciudad</option>

                      {ciudades.map((ciudad) => (
                        <option key={ciudad.idCiudad} value={ciudad.idCiudad}>
                          {ciudad.nombreCiudad}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {loading && (
                  <div className="mt-4">
                    <div className="d-flex justify-content-between">
                      <small className="text-secondary">Subiendo…</small>
                      <small className="text-secondary fw-semibold">
                        {uploadState}%
                      </small>
                    </div>

                    <div className="progress mt-2" style={{ height: 10 }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${uploadState}%` }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-12 col-lg-3">
              <div className="sticky-top" style={{ top: 16 }}>
                <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 fw-semibold">Fotografía</h6>
                    <span className="badge text-bg-light border text-secondary rounded-pill">
                      Opcional
                    </span>
                  </div>

                  <hr className="my-3" />

                  <div className="border rounded-4 overflow-hidden bg-white">
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: 420 }}
                    >
                      {preview !== "" ? (
                        <img
                          src={preview}
                          alt="Vista previa"
                          className="w-100 h-100"
                          style={{ objectFit: "cover" }}
                        />
                      ) : (
                        <div className="text-center text-secondary px-3">
                          <div className="fs-1 mb-2">👤</div>
                          <div className="fw-semibold">Sin imagen</div>
                          <div className="small">
                            Selecciona una fotografía
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-3">
                    <input
                      type="file"
                      id="fileInput"
                      name="imgInstructor"
                      className="d-none"
                      accept="image/*"
                      capture="environment"
                      onChange={handleFileChange}
                    />

                    <div className="input-group">
                      <span className="input-group-text bg-white text-secondary">
                        Archivo
                      </span>

                      <input
                        type="text"
                        id="fileName"
                        className="form-control text-secondary"
                        placeholder="Ningún archivo seleccionado"
                        readOnly
                      />
                    </div>

                    <label
                      id="fileLabel"
                      htmlFor="fileInput"
                      className="btn btn-outline-secondary w-100 mt-2 fw-semibold"
                    >
                      Seleccionar / Cambiar
                    </label>
                  </div>
                </div>

                <div className="mt-3 bg-white border rounded-4 shadow-sm p-3">
                  <div className="small text-secondary">
                    <i className="fa-regular fa-circle-check me-2"></i>
                    La imagen se optimiza automáticamente antes de enviarse.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 mt-4">
            <div className="col-12 col-md-6">
              <button
                type="submit"
                className="btn btn-dark w-100 fw-semibold py-2"
                disabled={loading || !puedeActualizar}
              >
                {loading ? "Guardando..." : "Guardar cambios"}
              </button>
            </div>

            <div className="col-12 col-md-6">
              <button
                type="button"
                className="btn btn-outline-secondary w-100 fw-semibold py-2"
                onClick={() => navigate("/perfil")}
                disabled={loading}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const InputTexto = ({
  label,
  value,
  setValue,
  required = false,
  type = "text",
  col = "col-12 col-md-6 col-xl-3",
  disabled = false,
}) => (
  <div className={col}>
    <label className="form-label small text-secondary text-uppercase">
      {label}
    </label>

    <input
      type={type}
      className="form-control"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required={required}
      disabled={disabled}
    />
  </div>
);

const SelectSimple = ({
  label,
  value,
  setValue,
  opciones = [],
  required = false,
  disabled = false,
}) => (
  <div className="col-6 col-md-3">
    <label className="form-label small text-secondary text-uppercase">
      {label}
    </label>

    <select
      className="form-select"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required={required}
      disabled={disabled}
    >
      <option value="">Seleccione</option>

      {opciones.map((opcion) => (
        <option key={opcion} value={opcion}>
          {opcion}
        </option>
      ))}
    </select>
  </div>
);

export default Mi_Perfil_Editar;